var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStackSimple = function SvgIconStackSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.496 2.507a1 1 0 0 0-.992 0l-10.5 6a1 1 0 0 0 0 1.736l10.5 6a1 1 0 0 0 .992 0l10.5-6a1 1 0 0 0 0-1.736zM12 14.223 3.516 9.375 12 4.527l8.485 4.848z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.996 13.007a1 1 0 1 0-.992 1.736l10.5 6a1 1 0 0 0 .992 0l10.5-6a1 1 0 1 0-.992-1.736L12 18.723z"
  }))));
};
export default SvgIconStackSimple;